import { HowCategoryRatingPresenter } from '@/presentation/presenters/dashboard/howCategoryRatingPresenter'
import { CategoryRatingViewModel } from '@/presentation/viewmodels/dashboard/categoryRatingViewModel'

export function useHowCategoryRatingPresenter(
  presenter: HowCategoryRatingPresenter = new HowCategoryRatingPresenter(new CategoryRatingViewModel())
) {
  return {
    isLoading: presenter.isLoading,
    error: presenter.error,
    chartData: presenter.chartData,
    chartSeries: presenter.chartSeries,
    chartOptions: presenter.chartOptions,
    hasData: presenter.hasData,
    initChart: presenter.initChart.bind(presenter)
  }
}
